module.exports = __webpack_public_path__ + "img/legacy_6.c0ed2116.jpg";